var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-conetent"},[_c('div',{staticClass:"chart-title",on:{"click":_vm.showDetail}},[_vm._v("收支-当前ROI >")]),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.chartLoading),expression:"chartLoading"}],ref:"chartRef",staticStyle:{"height":"400px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }